/**
 * 函数防抖
 * @param {function} fn
 * @param {number} delay
 */
export function debounce(fn, delay = 100) {
  let timer = null;
  let root = window;
  if (typeof global === 'object') {
    root = global;
  }

  return function(...args) {
    if (timer) {
      root.clearTimeout(timer);
      timer = null;
    }

    timer = setTimeout(fn.bind(null, ...args), delay);
  };
}

export function throttle(fn, delay) {}
